export const publisherNames = {
  vitalSource: 'VitalSource',
  wileyPlus: 'WileyPLUS'
} 
